import { render, staticRenderFns } from "./brokerageList.vue?vue&type=template&id=2b7743ba&scoped=true"
import script from "./brokerageList.vue?vue&type=script&lang=js"
export * from "./brokerageList.vue?vue&type=script&lang=js"
import style0 from "./brokerageList.vue?vue&type=style&index=0&id=2b7743ba&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../viewport/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b7743ba",
  null
  
)

export default component.exports